import axios from "axios";
import {
  errorMessage,
  tokenExpired,
  errorAlert,
  warningMessageWithoutConfimation
} from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    totalHuCount: null,
    totalWeight: null,
    totalDensityAndVolume: null
  },
  getters: {
    showTotalHuCount(state) {
      return state.totalHuCount;
    },
    showTotalWeight(state) {
      return state.totalWeight;
    },
    showTotalDensityAndVolume(state) {
      return state.totalDensityAndVolume;
    }
  },
  mutations: {
    setTotalHuCount(state, newTotalHuCount) {
      state.totalHuCount = newTotalHuCount;
    },
    setTotalWeight(state, newTotalWeight) {
      state.totalWeight = newTotalWeight;
    },
    setTotalDensityAndVolume(state, newTotalDensityAndVolume) {
      state.totalDensityAndVolume = newTotalDensityAndVolume;
    }
  },
  actions: {
    async getTotalHuCount({ commit }, huCounts) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/get_total_hu_count/`,
          huCounts,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setTotalHuCount", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getTotalWeight({ commit }, weights) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/operations/get_total_weight/`,
          weights,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setTotalWeight", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    /* async getCalculateLinearFeet(__, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/v2/calculate-linear-feet/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status == 401) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    } */
    async getCalculateVolumeAndDensity({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/calculate-volume-density/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setTotalDensityAndVolume", response.data);
          return response;
        }
      } catch (err) {
        if (err.response.status == 404) {
          return err.response;
        } else if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getCalculateLinearFeetLTL(__, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/v3/calculate-linear-feet/?container=${info.container}`,
          info.body,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status == 401) {
          tokenExpired();
        } else if (err.response.status == 400) {
          errorAlert("Error", "The load does not fit in that container");
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getCalculateLinearFeetFTL(__, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/operations/v4/calculate-linear-feet/?container=${info.container}&mode=${info.mode}`,
          info.body,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status == 401) {
          tokenExpired();
        } else if (err.response.status == 400) {
          errorAlert("Error", "The load does not fit in that container");
        } else if (err.response.status === 422) {
          warningMessageWithoutConfimation(
            "Select an equipment type before calculating"
          );
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
